import { Suspense } from "react";
import { WindowFrame } from "../wm/WindowFrame";
import styles from "./apps.module.css";
import type { AppDef } from "./registry";

/**
 * Ventana-app genérica (F0-T07): WindowFrame + Suspense del componente lazy.
 * El fallback es diegético — el OS "habilita el módulo", no "carga un chunk".
 */

export function AppWindow({ app }: { app: AppDef }) {
  return (
    <WindowFrame id={app.id} title={app.title}>
      <Suspense fallback={<div className={styles.moduleLoading}>Habilitando módulo…</div>}>
        <app.component />
      </Suspense>
    </WindowFrame>
  );
}
